export const EVT_BALLOON = 'customerBalloon';
export const EVT_COMPLETE_REGISTRATION_ERROR = 'completeRegistrationError';
export const EVT_ERROR_PAGE = 'errorPage';
export const EVT_LOGIN_ERROR = 'loginError';
export const EVT_LOGIN_SUCCESS = 'loginSucces';
export const EVT_LOGOUT_SUCCESS = 'logoutSuccess';
export const EVT_REGISTER_ERROR = 'registerError';
export const EVT_REGISTER_SUCCESS = 'registerSucces';
export const EVT_REQ_RESET_LINK = 'reqResetLink';
export const EVT_BUTTON_CLICK = 'click.button';
export const EVT_LINK_CLICK = 'click.link';
export const EVT_SHOW_ERROR = 'show.error';
export const EVT_ONBOARDING_CATEGORY = 'onboarding';

export const EVT_SESSION_START = 'SESSION_START';
export const EVT_SESSION_START_EVENT_NAME = 'startSession';

export const EVT_ONBOARDING_SUBMIT_GENDER = 'EVT_ONBOARDING_SUBMIT_GENDER';
export const EVT_ACTION_SUBMIT_GENDER = 'submit.gender';
export const EVT_ONBOARDING_SKIP_GENDER = 'EVT_ONBOARDING_SKIP_GENDER';
